
import { Component, Prop, Vue } from "vue-property-decorator";

import IMAGE_SMILE from "@/assets/images/V2/widget-img_smile.png";
import IMAGE_SYMBOLS from "@/assets/images/V2/widget-img_symbols.png";
import IMAGE_STARS from "@/assets/images/V2/widget-img_stars.png";

@Component
export default class SectionInformation extends Vue {
  @Prop({ type: String, default: null }) readonly type: string;
  @Prop({ type: String, default: null }) readonly title: string;
  @Prop({ type: String, default: null }) readonly text: string;
  @Prop({ type: String, default: null }) readonly image: string;
  @Prop({ type: String, default: null }) readonly buttonLabel: string;
  @Prop({ type: String, default: null }) readonly buttonIcon: string;
  @Prop({ type: Function }) readonly action;

  IMAGE_SMILE = IMAGE_SMILE;
  IMAGE_SYMBOLS = IMAGE_SYMBOLS;
  IMAGE_STARS = IMAGE_STARS;

  get showImageSmile() {
    return this.type === "avoidRisks";
  }

  get showImageSymbols() {
    return this.type === "trialExpiringSoon";
  }

  get showImageStars() {
    return this.type === "upgradeToPremium";
  }
}
